import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import { IamUser } from '@m/types/api/iam/Iam';
import { apiFetchV2 } from '@m/utils/http';
import { normalizeIamUser } from 'apps/admin/services/iam/IamUserService';

export type GetUserInfoResponse = IamUser | null;

export const IamUserService = {
  /**
   * User information
   * @param userId
   * @param roleId - undefined if you're searching for logged in user
   */
  getUser: async ({ userId }: { userId: string }): Promise<GetUserInfoResponse> => {
    const res = await apiFetchV2(`/v3/portal/user/iam/realm/users/${userId}`, {
      statusCodes: true,
    });
    if (res?.subject) {
      return normalizeIamUser(res.subject);
    }
    return null;
  },

  getLoggedInUser: async (): Promise<GetUserInfoResponse> => {
    const tokenParsed = KeycloakService.getTokenParsed();
    if (tokenParsed?.sub) {
      const userId = tokenParsed?.sub;
      return IamUserService.getUser({ userId });
    }
    throw new Error('No user found');
  },
};
